/* ==========================================================================
   Siraat — cart reservation countdown
   --------------------------------------------------------------------------
   Renders into [data-cart-reserve] inside the cart drawer. One instance, one
   timer, same shape as siraat-sale-countdown.js:

     - one pass per second, self-scheduled onto the wall-clock second, so it
       never drifts and never double-fires
     - the loop stops entirely while the tab is hidden and resyncs on return
     - the deadline lives in localStorage, so it survives navigation instead
       of restarting on every page load

   Deliberately NOT evergreen. The deadline is seeded once, when the cart
   first has something in it, and it is not reseeded when it runs out. At zero
   the strip removes itself. Emptying the cart clears the deadline, so the next
   cart gets a fresh one. A timer that silently restarts is the kind of thing
   a shopper notices on the second visit, and the cart is the worst place to
   be caught at it.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__siraatCartReserve) return; /* exactly one loop */
  window.__siraatCartReserve = true;

  var KEY = 'siraat_cart_reserve_until';
  var timer = null;
  var until = 0;
  var expired = false;

  function read() {
    try {
      var v = parseInt(localStorage.getItem(KEY), 10);
      if (!isNaN(v) && v) return v;
    } catch (e) {}
    return window.__siraatCartReserveUntil || 0;
  }

  function write(v) {
    window.__siraatCartReserveUntil = v;
    try {
      if (v) localStorage.setItem(KEY, String(v));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function nodes() {
    return document.querySelectorAll('[data-cart-reserve]');
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function cartIsEmpty() {
    /* the drawer hides one of these two wrappers depending on item count */
    var filled = document.querySelector('.cart-drawer__filled-state');
    if (filled) return filled.hidden === true;
    return false;
  }

  function tick() {
    var els = nodes();
    if (!els.length) return;

    var minutes = parseInt(els[0].getAttribute('data-minutes'), 10) || 10;

    if (cartIsEmpty()) {
      /* a fresh cart gets a fresh clock, including after one ran out */
      write(0);
      until = 0;
      expired = false;
      for (var e = 0; e < els.length; e++) els[e].hidden = true;
      return;
    }

    if (!until) {
      until = read();
      if (!until || until <= Date.now()) {
        until = Date.now() + minutes * 60 * 1000;
        write(until);
      }
    }

    var left = until - Date.now();

    if (left <= 0) {
      /* no reseed: the strip goes away rather than starting a new lie */
      for (var i = 0; i < els.length; i++) els[i].hidden = true;
      expired = true;
      return stop();
    }

    var s = Math.floor(left / 1000);
    var text = Math.floor(s / 60) + ':' + pad(s % 60);

    for (var j = 0; j < els.length; j++) {
      els[j].hidden = false;
      var out = els[j].querySelector('[data-cart-reserve-time]');
      if (out && out.textContent !== text) out.textContent = text;
    }
  }

  function stop() {
    clearTimeout(timer);
    timer = null;
  }

  function loop() {
    tick();
    clearTimeout(timer);
    /* Keep ticking even when the node is momentarily absent: the drawer
       replaces its whole contents on every cart update, so a pass that lands
       mid-render sees nothing and the next one sees the fresh node. Only a
       run-out clock stops the loop for good. */
    if (document.hidden || expired) return;
    timer = setTimeout(loop, 1000 - (Date.now() % 1000));
  }

  function resync() {
    until = 0;        /* re-read storage on the next pass */
    expired = false;  /* another tab may have started a new cart */
    loop();
  }

  document.addEventListener('visibilitychange', loop);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) resync();
  });
  /* the drawer re-renders its contents on every cart change */
  document.addEventListener('cart:change', loop);
  document.addEventListener('cart:refresh', loop);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }
})();
